export * from "-!../../../node_modules/extract-text-webpack-plugin/loader.js??ref--5-0!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js??ref--5-2!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!./tailwind.css?vue&type=style&index=0&prod&lang=css&external"


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/tailwind.css?vue&type=style&index=0&prod&lang=css&external
// module id = E1Wx
// module chunks = 7